import Axios, { CancelTokenSource } from 'axios';
import React, { useEffect } from 'react';

import { useTrackfyApi } from '../../hooks/useTrackfyApi';
import { useAuthContext } from '../../stores/AuthContext';
import { useConformityContext } from './context/ConformityContext';
import { OptionsContainer } from '../../components/PageStructure/styles';
import { DateRangePicker } from '../../components';
import AntdSelect from '../../components/Forms/Selects/AntdSelect';
import { mixpanelTrack } from '../../services/SystemMonitor';
import { getFollowingFriday } from '../../utils/DateTime';
import { useAuth } from '../../hooks';

const ConformityOptions: React.FC = () => {
  const {
    companies,
    professions,
    areas,
    companiesState,
    professionsState,
    areasState,
    getAreasApi,
    getCompaniesApi,
    getProfessionsApi,
  } = useTrackfyApi();
  const { setAreaSelected, setCompanySelected, setProfessionSelected, updatePeriod } =
    useConformityContext();
  const {authData} = useAuthContext();
  const compIds:string = authData? authData.grpCompanies:'t';
  const { USER_NAME } = useAuth();
  const userName = localStorage.getItem(USER_NAME);
  const { monitorAgent } = useAuthContext();
  
  useEffect(() => {
    let mounted = true;
    const currentRequest: CancelTokenSource = Axios.CancelToken.source();

    if (mounted){
      mixpanelTrack(monitorAgent, 'Indicadores - Conformidade', userName, authData);  
      getAreasApi(currentRequest.token);
    } 

    return () => {
      mounted = false;
      currentRequest.cancel('Conformity - getAreasApi request canceled by the user.');
    };
  }, []);

  useEffect(() => {
    let mounted = true;
    const currentRequest: CancelTokenSource = Axios.CancelToken.source();

    if (mounted) getCompaniesApi(currentRequest.token);

    return () => {
      mounted = false;
      currentRequest.cancel('Conformity - getCompaniesApi request canceled by the user.');
    };
  }, []);

  useEffect(() => {
    let mounted = true;
    const currentRequest: CancelTokenSource = Axios.CancelToken.source();

    if (mounted) getProfessionsApi(currentRequest.token);

    return () => {
      mounted = false;
      currentRequest.cancel('Conformity - getProfessionsApi request canceled by the user.');
    };
  }, []);

  return(
    <OptionsContainer>
      {((compIds!="a") && (!compIds.includes(",")))?
          <></>:
          <div>
            <AntdSelect dataRequestState={companiesState}
                        data={companies}
                        handleChange={(e: any) => {
                          setCompanySelected(parseInt(e, 10));
                          //pendoTrack('Indicadores', 'Conformidade - Filtro de empresas', 'Alteração');
                        }}
                        initialValue="Empresas"
              />
          </div>
      }
      <div>
        <AntdSelect dataRequestState={professionsState}
                    data={professions}
                    handleChange={(e: any) => {
                      setProfessionSelected(parseInt(e, 10));
                      //pendoTrack('Indicadores', 'Conformidade - Filtro de funções', 'Alteração');
                    }}
                    initialValue="Funções"
        />
      </div>
      <div>
        <AntdSelect dataRequestState={areasState}
                    data={areas}
                    handleChange={(e: any) => {
                      setAreaSelected(parseInt(e, 10));
                      //pendoTrack('Indicadores', 'Conformidade - Filtro de áreas', 'Alteração');
                    }}
                    initialValue="Áreas"
          />
      </div>
      <div>
        <DateRangePicker updatePeriod={updatePeriod}
                         screen="Indicadores"
                         maxDate={getFollowingFriday(new Date())}
                         component="Conformidade - "
                         selectRange
                        showToday
                        loadDate={new Date()}
        />
      </div>
      {/* <div><GeneratePdf /></div> */}
    </OptionsContainer>
  );
};

export default ConformityOptions;


/*return (
    <OptionsContainer>
      <OptionsRow>
        <OptionsRow>
        {((compIds!="a") && (!compIds.includes(",")))?
          <></>:
          <OptionsCol>
            <AntdSelect
              dataRequestState={companiesState}
              data={companies}
              handleChange={(e: any) => {
                setCompanySelected(parseInt(e, 10));
                pendoTrack('Indicadores', 'Conformidade - Filtro de empresas', 'Alteração');
              }}
              initialValue="Empresas"
            />
          </OptionsCol>
        }
          <OptionsCol>
            <AntdSelect
              dataRequestState={professionsState}
              data={professions}
              handleChange={(e: any) => {
                setProfessionSelected(parseInt(e, 10));
                pendoTrack('Indicadores', 'Conformidade - Filtro de funções', 'Alteração');
              }}
              initialValue="Funções"
            />
          </OptionsCol>
          <OptionsCol>
            <AntdSelect
              dataRequestState={areasState}
              data={areas}
              handleChange={(e: any) => {
                setAreaSelected(parseInt(e, 10));
                pendoTrack('Indicadores', 'Conformidade - Filtro de áreas', 'Alteração');
              }}
              initialValue="Áreas"
            />
          </OptionsCol>
          <OptionsCol>
            <DateRangePicker
              updatePeriod={updatePeriod}
              screen="Indicadores"
              maxDate={getFollowingFriday(new Date())}
              component="Conformidade - "
              selectRange
              showToday
              loadDate={new Date()}
            />
          </OptionsCol>
        </OptionsRow>
        {/* <div><GeneratePdf /></div> *///}
      /*</OptionsRow>
    </OptionsContainer>
  );*/